import LandingNew from "components/landing/LandingNew"

export default LandingNew